import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { RecoilRoot } from 'recoil'
import reportWebVitals from './reportWebVitals'
import router from './router'
import { ToastProvider } from './components/ui/toast'
import './index.css'
import './wave.css'
import './i18n'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <RecoilRoot>
    <ToastProvider>
      <RouterProvider router={router} />
    </ToastProvider>
  </RecoilRoot>
)

reportWebVitals()
